import { render, staticRenderFns } from "./BottomNavigationNew.vue?vue&type=template&id=60118868&scoped=true"
import script from "./BottomNavigationNew.vue?vue&type=script&lang=js"
export * from "./BottomNavigationNew.vue?vue&type=script&lang=js"
import style0 from "./BottomNavigationNew.vue?vue&type=style&index=0&id=60118868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60118868",
  null
  
)

export default component.exports